import { render, staticRenderFns } from "./mallProductList.vue?vue&type=template&id=5298a596&scoped=true&"
import script from "./mallProductList.vue?vue&type=script&lang=ts&"
export * from "./mallProductList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5298a596",
  null
  
)

export default component.exports